import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#31344A\" fill-rule=\"evenodd\" clip-path=\"url(#i1067507690__a)\" clip-rule=\"evenodd\"><path d=\"M9.303 1.571a7.731 7.731 0 1 0 0 15.463 7.731 7.731 0 0 0 0-15.463ZM0 9.303a9.303 9.303 0 1 1 18.606 0A9.303 9.303 0 0 1 0 9.303Z\"></path><path d=\"M14.766 14.766a.786.786 0 0 1 1.111 0l5.893 5.893a.786.786 0 0 1-1.111 1.11l-5.893-5.892a.786.786 0 0 1 0-1.111Z\"></path></g><defs><clipPath id=\"i1067507690__a\"><path fill=\"#fff\" d=\"M0 0h22v22H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }